import styled from '@emotion/styled';

export const Dashboard = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
`;

export const NotFoundMessage = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex: 1;
`;
